/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

module.exports = {
  name: 'ADGM',
  desc: 'ADGM Web App',
  prefix: 'adgm',
  footerText: 'ADGM All Rights Reserved 2021',
  logoText: 'ADGM',
};
